import MovieCard from "@/components/base/MovieCard";
import SectionTitle from "@/components/base/SectionTitle";
import type { Movie } from "@/types/movie";

interface MovieGridSectionProps {
  eyebrow: string;
  title: string;
  desc?: string;
  movies: Movie[];
  actionTo?: string;
  actionLabel?: string;
  showDesc?: boolean;
  columns?: 3 | 4;
}

export default function MovieGridSection({
  eyebrow,
  title,
  desc,
  movies,
  actionTo,
  actionLabel,
  showDesc = false,
  columns = 4,
}: MovieGridSectionProps) {
  const gridClass =
    columns === 3
      ? "grid grid-cols-2 gap-3 sm:grid-cols-2 md:gap-4 lg:grid-cols-3"
      : "grid grid-cols-2 gap-3 sm:grid-cols-2 md:grid-cols-3 md:gap-4 lg:grid-cols-4";

  return (
    <section className="mx-auto w-full max-w-[1360px] px-4 py-12 md:px-8 md:py-16">
      <SectionTitle
        eyebrow={eyebrow}
        title={title}
        desc={desc}
        actionLabel={actionLabel}
        actionTo={actionTo}
      />
      <div className={gridClass}>
        {movies.map((movie, index) => (
          <MovieCard key={movie.id} movie={movie} showDesc={showDesc} index={index} />
        ))}
      </div>
    </section>
  );
}